var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.0312 20.2922L25.4136 3.16398C24.8083 2.60715 24.0113 2.3058 23.1891 2.32293C22.3668 2.34005 21.583 2.67431 21.0015 3.25585L3.87872 20.3787L3 21.2574V46.5H19.5V30.75H28.5V46.5H45V21.1836L44.0312 20.2922ZM23.2536 5.32229C23.28 5.32229 23.2637 5.32801 23.2523 5.33916C23.2406 5.32801 23.2271 5.32229 23.2536 5.32229ZM42 43.5H31.5V30.75C31.5 29.9544 31.1839 29.1913 30.6213 28.6287C30.0587 28.0661 29.2956 27.75 28.5 27.75H19.5C18.7044 27.75 17.9413 28.0661 17.3787 28.6287C16.8161 29.1913 16.5 29.9544 16.5 30.75V43.5H6V22.5L23.2536 5.37713C23.2548 5.37601 23.2549 5.37498 23.2558 5.37385L42 22.5V43.5Z",
    fill: "#FCC67C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.e90e410a77aa8d07f51d47318c658b54.svg";
export { ForwardRef as ReactComponent };